import { PropsWithChildren } from "react";

import { cn } from "shared/utils/cn";

export const Page = ({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={cn(
        "flex w-full grow flex-col overflow-x-hidden",
        className?.includes("pt") ? "pt-0" : "pt-safe",
        className
      )}
    >
      {children}
    </div>
  );
};
